import {writable} from 'svelte/store';

const displayMessage = (messageType, msg, delay = null) => {
    let tm;
    if (delay === false) {
        tm = false;
    } else {
        tm = delay === null ? Notifier.delay : delay;
    }
    update(messages => {
        const m = {
            type: messageType,
            message: msg
        };
        if (tm) {
            setTimeout(() => hideMessage(m), Notifier.delay);
        }
        return [...messages, m];
    });
};

const hideMessage = message => {
    update(messages => messages.filter(m => m != message));
};

const {update, subscribe, set} = writable([]);

const Notifier = {
    subscribe
};

Notifier.delay = 2000;
Notifier.showMessage = (msg, delay = null) => displayMessage('notifier-notice', msg, delay);
Notifier.showError = (msg, delay = null) => displayMessage('notifier-error', msg, delay);

export default Notifier;